<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" class="home" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <NotFound v-else-if="!page || (page.type === 'Content'
      && !page.content)"></NotFound>
    <template v-else>
      <div class="cnt bcCnt" v-if="page.breadcrumb || page.showTitle">
        <div class="breadcrumb" v-if="page.breadcrumb"
          :class="{bcSm: page.type === 'Content' && page.content.type !== 'profile',
          bcMedia: page.type === 'Content' && !['article',
          'event', 'profile'].includes(page.content.type)}">
          <div class="bcItem"><a :href="`${$config.appPath}${langCode}`">
            <template v-if="lang === 'id'">Beranda</template>
            <template v-if="lang === 'en'">Home</template>
          </a></div>
          <div v-for="(bc, i) in page.parents" :key="`bc${i}`">
            <div class="bcItem bcItemMid" v-if="bc.type !== 'Submenu'">
              <span v-if="bc.type === 'Unclickable'">
                {{bc.name[lang]}}
              </span>
              <a :href="`${$config.appPath}${langCode}${bc.uri}`" v-else>
                {{bc.name[lang]}}
              </a>
            </div>
          </div>
          <div class="bcItem bcItemMore" v-if="page.parents.length > 0"><span>...</span></div>
          <div class="bcItem">
            <span>{{page.name[lang]}}</span>
          </div>
        </div>
        <h2 class="pageTitle" v-if="page.type !== 'Content'">{{page.name[lang]}}</h2>
      </div>
      <Contents v-if="page.type === 'Directory'"
        :page="page"></Contents>
      <Content v-else-if="page.type === 'Content'"
        :page="page"></Content>
      <Page v-else-if="page.type === 'Page'"
        :page="page"></Page>
      <template v-else-if="page.type === 'Pages'">
        <Page v-for="(p, i) in page.pages" :key="`p${i}`" :page="p"></Page>
      </template>
      <template v-else-if="1>2">
        {{page}}
      </template>
    </template>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import NotFound from '@/components/NotFound.vue';
import Contents from '@/components/Contents.vue';
import Content from '@/components/Content.vue';
import Page from '@/components/Page.vue';
import Footer from '@/components/Footer.vue';

const nanoid = require('nanoid');

export default {
  name: 'home',
  components: {
    Header,
    NotFound,
    Contents,
    Content,
    Page,
    Footer,
  },
  data() {
    return {
      scrolled: false,
      loading: true,
      page: null,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    if (this.$route.params.read && this.$route.params.read === 'v') {
      /**
       * Get article detail
       *
       */
      const { code } = this.$route.params;
      const menuCode = this.$route.path.split('/v')[0].replace(/^\/[a-z]+-[a-z]+\/?/, '').replace(/\//g, '_');
      let session = localStorage.getItem('icel_ua_session');
      if (!session) {
        session = nanoid.nanoid(64);
        localStorage.setItem('icel_ua_session', session);
      }
      this.$http.get(this.$config.uri(`article/${code}?menu=${menuCode}&session=${session}`)).then((r) => {
        if (r.data.status !== 200) {
          /**
           * Display not found page
           *
           */
          this.loading = false;
          return;
        }
        if (r.data.data.type === 'link') {
          window.location.href = r.data.data.linkUrl;
          return;
        }
        this.loading = false;
        this.page = {
          breadcrumb: 1,
          content: r.data.data,
          type: 'Content',
          parents: r.data.parents || [],
          showTitle: 1,
          name: r.data.data.title,
        };
        if (this.$route.params.m1 === 'search') {
          this.page.parents.push({
            type: 'Unclickable',
            name: { id: 'Pencarian', en: 'Search' },
          });
        }
      });
    } else {
      /**
       * Get menu detail
       *
       */
      const menuCode = this.$route.path.replace(/^\/[a-z]+-[a-z]+\/?/, '').replace(/\//g, '_');
      let session = localStorage.getItem('icel_ua_session');
      if (!session) {
        session = nanoid.nanoid(64);
        localStorage.setItem('icel_ua_session', session);
      }
      this.$http.get(this.$config.uri(`config/menu/${menuCode}?session=${session}`)).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          /**
           * Display not found page
           *
           */
          return;
        }
        this.page = r.data.data;
      });
    }
  },
};
</script>

<style scoped lang="scss">
.bcCnt{
  padding: 40px 0 0;
  @media (max-width: 640px) {
    padding: 20px 0 0;
  }
  .breadcrumb{
    display: flex;
    padding: 0 0 10px;
    overflow: hidden;
    &.bcSm{
      max-width: 750px;
      margin: 0 auto;
    }
    &.bcMedia{
      max-width: 900px;
    }
    .bcItem{
      padding-right: 40px;
      position: relative;
      color: #767676;
      &.bcItemMid{
        @media (max-width: 640px) {
          display: none;
        }
      }
      &.bcItemMore{
        display: none;
        @media (max-width: 640px) {
          display: block;
        }
      }
      span{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      a{
        transition: all .3s ease;
        font-weight: 600;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
      }
      &:after{
        content: "";
        position: absolute;
        right: 15px; top: 0; bottom: 0;
        width: 10px;
        background-image: url(../assets/arrow-right-black.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .65;
      }
    }
    > div:last-child{
      &:after{
        display: none;
      }
    }
  }
  .pageTitle{
    font-size: 34px;
    margin: 0;
  }
}
</style>
